// extracted by mini-css-extract-plugin
export default {"signRedirect":"BusinessCreatePassword_signRedirect__SRc7w","googleSign":"BusinessCreatePassword_googleSign__wO5sP","bottomContainer":"BusinessCreatePassword_bottomContainer__EViUA"};